import React from "react";
import clsx from "clsx";

import { PriorityTypes } from "types";

import styles from "./supportLevel.module.scss";
type SupportLevelIconProps = {
	name?: string;
	className?: string;
	canHaveEmptySpace?: boolean;
};
const SupportLevelIcon = ({
	name,
	className = "",
	canHaveEmptySpace = false,
}: SupportLevelIconProps) => {
	const isDiamond = value => {
		return (
			PriorityTypes.Diamond.name === value ||
			PriorityTypes.RedDiamond.name === value
		);
	};
	return (
		<>
			{(isDiamond(name) && (
				<div className={clsx(styles.iconHolder, className)}>
					<svg>
						<use href={`#${name}`}></use>
					</svg>
				</div>
			)) ||
				(canHaveEmptySpace && (
					<>
						<div className={styles.blankSpace}></div>
					</>
				))}
		</>
	);
};
export default SupportLevelIcon;
